import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import usersService from "../api/users";
import loginService from "../api/login";
import signupService from "../api/signup";

Vue.use(Vuex);

const initialState = {
  myMemories: [],
  currentUser: {},
  mySendRequests: [],
  myPendingRequests: [],
};

const getters = {
  myMemories(state) {
    return state.myMemories;
  },
  currentUser(state) {
    return state.currentUser;
  },
  mySendRequests(state) {
    return state.mySendRequests;
  },
  myPendingRequests(state) {
    return state.myPendingRequests;
  },
};

export const actions = {
  async login(context, payload) {
    try {
      const response = await loginService.login(payload);
      context.commit("setToken", response.data, { root: true });
      var backUrl = router.history.current.query.backUrl;
      if (backUrl) {
        router.push(decodeURIComponent(backUrl));
      } else {
        router.push("/MyMemories");
      }
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getUserProfile(context, payload) {
    try {
      const response = await loginService.getUserProfile(payload);
      localStorage.setItem("theme", response.data.theme);
      response.data.dateOfBirth = response.data.dateOfBirth.split("T")[0];
      context.commit("currentUser", response.data, { root: true });
      localStorage.setItem("currentUser", JSON.stringify(response.data));
      return Promise.resolve();
    } catch (error) {
      const errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async forgotPassword(context, payload) {
    try {
      const response = await loginService.forgotPassword(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.changed,
          color: "black",
        },
        { root: true }
      );
      context.rootState.auth.forgotPasswordConfirmation = {
        password: "",
        confirmPassword: "",
      };
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message:
            context.rootState.langObj.response.error[error] ||
            context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async forgotPasswordMail(context, payload) {
    try {
      const response = await loginService.forgotPasswordMail(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.sent,
          color: "black",
        },
        { root: true }
      );
      context.rootState.auth.forgotPassword = {
        username: "",
      };
      return Promise.resolve();
    } catch (error) {
      var errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async changePassword(context, payload) {
    try {
      const response = await loginService.changePassword(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.changed,
          color: "black",
        },
        { root: true }
      );
      context.rootState.auth.changePassword = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message:
            context.rootState.langObj.response.error[error.response.data] ||
            context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async signup(context, payload) {
    try {
      const response = await signupService.signUp(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.signedUp,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      var errorMessage =
        context.rootState.langObj.response.error[error.response.data] ||
        context.rootState.langObj.response.error.somethingWentWrong;
      context.commit(
        "toast",
        { message: errorMessage, color: "red lighten-2" },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async updateUserTheme(context, payload) {
    try {
      const response = await usersService.updateUserTheme(payload);
      context.state.currentUser.theme = payload.theme;
      localStorage.setItem("theme", payload.theme);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.themeSuccess,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async activateAccount(context, payload) {
    try {
      const response = await signupService.activateAccount(payload);
      context.commit(
        "toast",
        {
          message:
            context.rootState.langObj.response.success.yourAccountIsActivated,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message:
            context.rootState.langObj.response.error.invalidActivationLink,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async resendActivationAccountLink(context, payload) {
    try {
      const response = await signupService.resendActivationAccountLink(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.yourRequestSend,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      if (error.response.status == 404) {
        context.commit(
          "toast",
          {
            message: context.rootState.langObj.response.error.userNotFound,
            color: "red lighten-2",
          },
          { root: true }
        );
      } else if (error.response.status == 429) {
        context.commit(
          "toast",
          {
            message: context.rootState.langObj.response.error.tooManyRequests,
            color: "red lighten-2",
          },
          { root: true }
        );
      } else if (error.response.status == 400) {
        context.commit(
          "toast",
          {
            message:
              context.rootState.langObj.response.error.invalidEmailFormat,
            color: "red lighten-2",
          },
          { root: true }
        );
      } else {
        context.commit(
          "toast",
          {
            message:
              context.rootState.langObj.response.error.somethingWentWrong,
            color: "red lighten-2",
          },
          { root: true }
        );
      }
      return Promise.reject(error);
    }
  },
  logout(context) {
    var lang = window.localStorage.getItem("lang");
    var theme = window.localStorage.getItem("theme");
    localStorage.clear();
    if (lang) {
      window.localStorage.setItem("lang", lang);
    }
    if (theme) {
      window.localStorage.setItem("theme", theme);
    }
    context.rootState.token = null;
    context.rootState.user.currentUser = null;

    var color = "#3093a5";
    switch (theme || "no-theme") {
      case "no-theme":
      case "theme-default":
        color = "#3093a5";
        break;
      case "theme-black":
        color = "#000000";
        break;
      case "theme-blue-gray":
        color = "#607D8B";
        break;
      case "theme-blue":
        color = "#1E88E5";
        break;
      case "theme-cyan":
        color = "#00B8D4";
        break;
      case "theme-dark-red":
        color = "#D50000";
        break;
      case "theme-green":
        color = "#64DD17";
        break;
      case "theme-light-green":
        color = "#00C853";
        break;
      case "theme-light-brown":
        color = "#8D6E63";
        break;
      case "theme-lime-dark":
        color = "#9E9D24";
        break;
      case "theme-orange":
        color = "#F57C00";
        break;
      case "theme-pink":
        color = "#FF4081";
        break;
      case "theme-light-purple":
        color = "#E040FB";
        break;
      case "theme-purple":
        color = "#800080";
        break;
    }

    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", color);
  },
  async updateUserInfo(context, payload) {
    try {
      const response = await usersService.updateUserInfo(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.changed,
          color: "black",
        },
        { root: true }
      );
      context.dispatch("getUserProfile");
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async likeEntity(context, payload) {
    try {
      const response = await usersService.likeEntity(payload);
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async unlikeEntity(context, payload) {
    try {
      const response = await usersService.unlikeEntity(payload);
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getPendingRequests(context, payload) {
    try {
      const response = await usersService.getPendingRequests(payload);
      if (response.status != 204) {
        var result = response.data;
        context.state.myPendingRequests = result;
      } else {
        context.state.myPendingRequests = [];
      }
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getMyMemories(context, payload) {
    try {
      const response = await usersService.getMyMemories(payload);
      if (response.status != 204) {
        context.state.myMemories = response.data;
      } else {
        context.state.myMemories = [];
      }
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getMySendRequests(context, payload) {
    try {
      const response = await usersService.getMySendRequests(payload);
      if (response.status != 204) {
        context.state.mySendRequests = response.data;
      } else {
        context.state.mySendRequests = [];
      }
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async declineRequest(context, payload) {
    try {
      const response = await usersService.declineRequest(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.declined,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async acceptRequest(context, payload) {
    try {
      const response = await usersService.acceptRequest(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.acceptRequest,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
};

export const state = { ...initialState };

export default {
  namespaced: true,
  state,
  getters,
  actions,
};
